import React from 'react';
import PropTypes from 'prop-types';

const baseCls = 'lt-map-layers-message';

const LayersControlMessage = ({ onClose, children, tooltipOffset }) => (
  <div className={baseCls}>
    {onClose && (
      <button
        type="button"
        className={`${baseCls}__close`}
        onClick={onClose}
        aria-label="Закрыть"
      />
    )}
    <div
      className={`${baseCls}__tooltip`}
      style={tooltipOffset && { top: tooltipOffset }}
    />
    <div className={`${baseCls}__container`}>{children}</div>
  </div>
);

LayersControlMessage.defaultProps = {
  onClose: null,
  tooltipOffset: null,
};
LayersControlMessage.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  tooltipOffset: PropTypes.number,
};

export default LayersControlMessage;
